export const PublisherStatus = {
  archived: 'Archived',
  active: 'Active'
}


// WEBPACK FOOTER //
// ./src/constants/publisher.js